var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailAssistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.255 12.8664C11.7326 13.2147 11.1257 13.3989 10.5 13.3989C9.87435 13.3989 9.26748 13.2147 8.74502 12.8664L0.139822 7.12945C0.0920801 7.09762 0.0455684 7.06444 0 7.03031V16.431C0 17.5088 0.874658 18.3642 1.93319 18.3642H19.0668C20.1446 18.3642 21 17.4895 21 16.431V7.03027C20.9543 7.06448 20.9077 7.09774 20.8598 7.12961L12.255 12.8664Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.822363 6.10534L9.42756 11.8424C9.75331 12.0595 10.1266 12.1681 10.5 12.1681C10.8733 12.1681 11.2467 12.0595 11.5724 11.8424L20.1776 6.10534C20.6926 5.76224 21 5.18802 21 4.56828C21 3.50265 20.1331 2.63574 19.0675 2.63574H1.93253C0.866947 2.63578 0 3.50269 0 4.5693C0 5.18802 0.307453 5.76224 0.822363 6.10534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailAssistance);
export default __webpack_public_path__ + "static/media/icon-email-assistance.0e5626c047d1b89629d0b96e516e7145.svg";
export { ForwardRef as ReactComponent };